import React, { ReactNode } from "react";

interface DropdownItemProps {
  onClick: () => void;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
}

const DropdownItem: React.FC<DropdownItemProps> = ({
  onClick,
  children,
  className = "",
  disabled = false,
}) => {
  return (
    <button
      id="dropdown-menu-item"
      onClick={onClick}
      className={`block w-full text-left px-4 py-2 text-sm text-gray-700  ${!disabled ? "hover:bg-gray-100 transition-colors" : "italic opacity-50 cursor-not-allowed"} ${className}`}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export { DropdownItem };
